/**
 * Studio 19 condensed rental row (GRG-55) — Figma node 4738:6436.
 *
 * The whole rental block is injected at runtime by secure.studio19.com.au (see
 * snippets/studio19-widget.liquid, included globally from layout/theme.liquid), so
 * there is no Liquid to edit — we can only reshape what the vendor renders.
 *
 * Collapsed, the design is a single 50px row: logo · "Rent from $X per week" ·
 * chevron. Expanded, it reveals what the vendor already renders below the header
 * (the minimum-rental notes and the Apply Now / Learn More / Apply to Purchase Info
 * buttons). The buttons are never removed — hiding them outright would delete the
 * only route into the rental application.
 *
 * This file only wires up behaviour and state; all the visual work is the
 * `@layer sections` CSS in sections/pd-main-product.liquid, scoped to that
 * section so the legacy product template is untouched.
 *
 * Vendor DOM (verified 2026-08-17):
 *   .studio19-wrapper > .s19-component
 *     > .s19-header          ( .s19-rentfor, .s19-price-per-period, img.s19-s19logo )
 *     > .s19-rental-details  ( span.s19-min-period x2 )
 *     > .s19-actions         ( a.s19-apply-btn, a.s19-learn-btn, a.s19-purchase-btn )
 */
(function () {
  'use strict';

  var READY = 'pd-s19--ready';
  var OPEN = 'is-open';

  function enhance(wrapper) {
    if (!wrapper || wrapper.classList.contains(READY)) return;
    var header = wrapper.querySelector('.s19-header');
    if (!header) return; // vendor markup not finished rendering yet

    wrapper.classList.add(READY);

    // The header becomes the disclosure control. It is a <div> we do not own, so
    // give it button semantics rather than wrapping it (moving vendor nodes risks
    // breaking their own listeners).
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', 'false');

    var label = wrapper.querySelector('.s19-price-per-period');
    if (label && !header.getAttribute('aria-label')) {
      header.setAttribute('aria-label', 'Rent from ' + label.textContent.replace(/\s+/g, ' ').trim() + ' — show rental details');
    }

    function toggle() {
      var open = wrapper.classList.toggle(OPEN);
      header.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    header.addEventListener('click', function (evt) {
      // let a real link inside the header do its own thing
      if (evt.target.closest('a')) return;
      toggle();
    });

    header.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Enter' && evt.key !== ' ' && evt.key !== 'Spacebar') return;
      evt.preventDefault();
      toggle();
    });
  }

  function scan() {
    document.querySelectorAll('.studio19-wrapper').forEach(enhance);
  }

  // The vendor script appends asynchronously and can re-render, so watch rather
  // than run once. Disconnect after a ceiling so we are not observing forever.
  function watch() {
    scan();
    if (typeof MutationObserver !== 'function') return;
    var observer = new MutationObserver(scan);
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
      scan();
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
